

const freeShippingThresholds = {
    "CZ": 2000.00, // CZK
    "DK": 700.00,  // DKK
    "NO": 1500.00, // NOK
    "US": 100.00,  // USD
    "CA": 140.00,  // CAD
    "AU": 150.00,  // AUD
    "NZ": 170.00,  // NZD
    "SG": 100.00,  // SCG
    "CH": 90.00,    // CHF
      
    // EU countries using Euro
    "AT": 100.00,  // EUR
    "BE": 100.00,  // EUR
    "CY": 100.00,  // EUR
    "EE": 100.00,  // EUR
    "FI": 100.00,  // EUR
    "FR": 100.00,  // EUR
    "DE": 100.00,  // EUR
    "GR": 100.00,  // EUR
    "IE": 100.00,  // EUR
    "IT": 100.00,  // EUR
    "LV": 100.00,  // EUR
    "LT": 100.00,  // EUR
    "LU": 100.00,  // EUR
    "MT": 100.00,  // EUR
    "NL": 100.00,  // EUR
    "PT": 100.00,  // EUR
    "SI": 100.00,  // EUR
    "SK": 100.00   // EUR
};

const currencySymbols = {
    "CZ": "Kč",    // Czech Koruna (CZK)
    "DK": "kr",    // Danish Krone (DKK)
    "NO": "kr",    // Norwegian Krone (NOK)
    "US": "$",     // US Dollar (USD)
    "CA": "$",     // Canadian Dollar (CAD)
    "AU": "$",     // Australian Dollar (AUD)
    "NZ": "$",     // New Zealand Dollar (NZD)
    "SG": "$",     // Singapore Dollar (SGD)
    "CH": "CHF",   // Swiss Franc (CHF)

    // EU countries using Euro
    "AT": "€",     // Euro (EUR)
    "BE": "€",     // Euro (EUR)
    "CY": "€",     // Euro (EUR)
    "EE": "€",     // Euro (EUR)
    "FI": "€",     // Euro (EUR)
    "FR": "€",     // Euro (EUR)
    "DE": "€",     // Euro (EUR)
    "GR": "€",     // Euro (EUR)
    "IE": "€",     // Euro (EUR)
    "IT": "€",     // Euro (EUR)
    "LV": "€",     // Euro (EUR)
    "LT": "€",     // Euro (EUR)
    "LU": "€",     // Euro (EUR)
    "MT": "€",     // Euro (EUR)
    "NL": "€",     // Euro (EUR)
    "PT": "€",     // Euro (EUR)
    "SI": "€",     // Euro (EUR)
    "SK": "€"      // Euro (EUR)
};


const fastestShippingTimes = {
  "GB": { days_min: 1, days_max: 1, service: "DPD Local Next Day" },
  "Northern_Ireland": { days_min: 1, days_max: 1, service: "DPD Local Next Day" },
  "Isle_of_Wight": { days_min: 1, days_max: 1, service: "DPD Local Next Day" },
  "Scottish_Islands": { days_min: 2, days_max: 2, service: "DPD Local Two Day" },
  "Scottish_Highlands": { days_min: 2, days_max: 2, service: "DPD Local Two Day" },
  "Channel_Islands": { days_min: 2, days_max: 2, service: "DPD Local Two Day" },
  "Isle_of_Man": { days_min: 2, days_max: 2, service: "DPD Local Two Day" },
  "AU": { days_min: 5, days_max: 7, service: "DPD Air Express" },
  "CA": { days_min: 2, days_max: 4, service: "DPD Air Express" },
  "US": { days_min: 2, days_max: 4, service: "DPD Air Express" },
  "NZ": { days_min: 6, days_max: 7, service: "DPD Air Express" },
  "SG": { days_min: 2, days_max: 4, service: "DPD Air Express" },
  "CH": { days_min: 3, days_max: 4, service: "DPD Air Express" },
  "CY": { days_min: 3, days_max: 6, service: "DPD Air Classic" },
  "CN": { days_min: 4, days_max: 13, service: "DPD Air Classic" },
  "HK": { days_min: 3, days_max: 5, service: "DPD Air Classic" },
  "IS": { days_min: 3, days_max: 5, service: "DPD Air Classic" },
  "JP": { days_min: 3, days_max: 6, service: "DPD Air Classic" },
  "MX": { days_min: 4, days_max: 7, service: "DPD Air Classic" },
  "NO": { days_min: 3, days_max: 6, service: "DPD Air Classic" },
  "ZA": { days_min: 4, days_max: 6, service: "DPD Air Classic" },
  "AT": { days_min: 3, days_max: 4, service: "DPD Classic" },
  "BE": { days_min: 2, days_max: 3, service: "DPD Classic" },
  "BG": { days_min: 5, days_max: 6, service: "DPD Classic" },
  "HR": { days_min: 4, days_max: 5, service: "DPD Classic" },
  "CZ": { days_min: 3, days_max: 3, service: "DPD Classic" },
  "DK": { days_min: 3, days_max: 4, service: "DPD Classic" },
  "EE": { days_min: 5, days_max: 6, service: "DPD Classic" },
  "FI": { days_min: 5, days_max: 6, service: "DPD Classic" },
  "FR": { days_min: 2, days_max: 4, service: "DPD Classic" },
  "DE": { days_min: 3, days_max: 4, service: "DPD Classic" },
  "GR": { days_min: 6, days_max: 8, service: "DPD Classic" },
  "HU": { days_min: 4, days_max: 5, service: "DPD Classic" },
  "IT": { days_min: 3, days_max: 4, service: "DPD Classic" },
  "LV": { days_min: 5, days_max: 6, service: "DPD Classic" },
  "LT": { days_min: 5, days_max: 5, service: "DPD Classic" },
  "LU": { days_min: 2, days_max: 3, service: "DPD Classic" },
  "NL": { days_min: 2, days_max: 3, service: "DPD Classic" },
  "PL": { days_min: 3, days_max: 4, service: "DPD Classic" },
  "PT": { days_min: 4, days_max: 5, service: "DPD Classic" },
  "RO": { days_min: 5, days_max: 6, service: "DPD Classic" },
  "SI": { days_min: 4, days_max: 5, service: "DPD Classic" },
  "ES": { days_min: 4, days_max: 4, service: "DPD Classic" },
  "SE": { days_min: 3, days_max: 4, service: "DPD Classic" },
  "IE": { days_min: 3, days_max: 5, service: "Royal Mail International Tracked" },
  "IL": { days_min: 5, days_max: 7, service: "Royal Mail International Tracked" },
  "TR": { days_min: 5, days_max: 7, service: "Royal Mail International Tracked" },
  "UA": { days_min: 5, days_max: 7, service: "Royal Mail International Tracked" }
};



// function updateProgressBar(cartTotal, freeShippingThreshold) {
//   const progress = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
//   const progressBar = document.getElementById("free-shipping-progress-bar");
//   const progressText = document.getElementById("free-shipping-progress-bar-text");

//   progressBar.style.width = `${progress}%`;

//   if (cartTotal >= freeShippingThreshold) {
//     progressText.textContent = "Congratulations! You’ve unlocked free shipping!";
//     progressBar.style.background = "#00c853"; // Change to green on success.
//   } else {
//     const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
//     progressText.textContent = `Spend £${remaining} more to get free shipping!`;
//     progressBar.style.background = "#4caf50";
//   }
// }


// Calculate the progress number, and the width of the progress bar.
function calculateProgress(currentVal, targetVal) {
  var progressBar = document.querySelectorAll('.cart-shippingThreshold__progress');
  var progressNum = document.querySelectorAll('.cart-shipping__num');
  var progressOuter = document.querySelectorAll('.cart-shipping__numOuter');
  var successMsg = document.querySelectorAll('.cart-shipping__success');
  // calculate how far progress is from the total as a percentage
  var result = Math.round(currentVal * 100 / targetVal);
  console.log('currentval:' + currentVal + ' targetval:' + targetVal + ' result:' + result);
  progressBar.forEach(function(el){
    el.setAttribute('style', "width: ".concat(result, "%"));
  })
   // Update the progess text. If threshold is met, show success message
  var newProgressNum = (targetVal - currentVal).toFixed(2);
  console.log('newProgressNum:' + newProgressNum);
  if(newProgressNum <= 0){
    progressOuter.forEach(function(el){
      el.style.display = 'none';
      el.style.transition = "opacity 5s";
      el.style.opacity = '0';
    });
    successMsg.forEach(function(el){
      el.style.display = 'block';
      el.style.transition = "opacity 5s";
      el.style.opacity = '1';
    });
    progressNum.forEach(function(el){
      el.textContent = newProgressNum;
    });
  } else {
    successMsg.forEach(function(el){
      el.style.display = 'none';
      el.style.transition = "opacity 5s";
      el.style.opacity = '0';
    });
    progressOuter.forEach(function(el){
      el.style.display = 'block';
      el.style.transition = "opacity 5s";
      el.style.opacity = '1';
    });
    progressNum.forEach(function(el){
      el.textContent = newProgressNum;
    });
  }
};


updateShippingBanner = function () {
    console.log('updateShippingBanner()');
    const freeShippingThreshold = freeShippingThresholds[Shopify.country] || null; // Free shipping threshold in store currency
    const currencySymbol = currencySymbols[Shopify.country] || "";

    let freeShippingMsg = null;
    if (Shopify.country == "GB") {
      freeShippingMsg = `Free shipping on all UK orders`;
    } else {
      if (freeShippingThreshold != null) {
        freeShippingMsg = `Free shipping on orders over ${currencySymbol}${freeShippingThreshold}`;
      }
    }
    console.log('updateShippingBanner() freeShippingMsg:', freeShippingMsg);

    shippingMessages_thresh = document.querySelectorAll('.shipping-message-product-page-threshold');
    shippingMessages_thresh.forEach(function(el){
      el.innerHTML = `<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-truck"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" /><path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" /><path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5" /></svg>
                      <span style='padding-left: 8px;' class='caption'>${freeShippingMsg}</span>`;
    });

    let speedMsg = null;
    if (Shopify.country == "GB") {  
      speedMsg = 'Free upgrade to next day delivery on orders above £75';
    } else {
      const dest = fastestShippingTimes[Shopify.country];
      speedMsg = `Shipping times from ${dest['days_min']}-${dest['days_max']} days`;
    }  
    shippingMessages_speed = document.querySelectorAll('.shipping-message-product-page-speed');
    shippingMessages_speed.forEach(function(el){
      el.innerHTML = `<svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class="icon icon-tabler icons-tabler-outline icon-tabler-cube-send"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M16 12.5l-5 -3l5 -3l5 3v5.5l-5 3z" /><path d="M11 9.5v5.5l5 3" /><path d="M16 12.545l5 -3.03" /><path d="M7 9h-5" /><path d="M7 12h-3" /><path d="M7 15h-1" /></svg>
                      <span style='padding-left: 8px;' class='caption'>${speedMsg}</span>`;
    });
  
    
    
  
    if (!freeShippingThreshold) {
      console.log("no freeshippingthreshold value");
      return false;
    }
    console.log('detected change in the cart... [updateShippingBanner]');

    // Fetch the current cart information
    fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
            const cartTotal = cart.total_price / 100; // Convert cents to dollars
            console.log("cartTotal:", cartTotal, "; freeShippingThreshold:", freeShippingThreshold)

            calculateProgress(cartTotal, freeShippingThreshold);
          
            // const banner = document.getElementById("free-shipping-banner");
            // const message = document.getElementById("free-shipping-message");
            const bannerTexts = document.querySelectorAll('.free-shipping-message');
          
            if (cartTotal >= freeShippingThreshold) {
                // message.textContent = "Congrats! You've got free shipping!";
                // banner.style.display = "block";
                bannerMsg = "Congrats! You've got free shipping!";
              
                const cartMessages = document.querySelectorAll(".tax-note");
                cartMessages.forEach(function(el){
                  if (el.textContent.includes("Tax included")) {
                    el.textContent = "Tax included. Free shipping";
                  }
                });
            } else {
                const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
                if (remaining == freeShippingThreshold) {
                  bannerMsg = `Free shipping on orders over ${currencySymbol}${freeShippingThreshold}`;
                } else {
                  bannerMsg = `Add ${currencySymbol}${remaining} more to your cart for free shipping!`;
                }
                // banner.style.display = "block";
            }

            console.log(bannerMsg);
            bannerTexts.forEach(function(el){
                el.textContent = bannerMsg;
            });
          
        })
        .catch(error => console.error("Error fetching cart data:", error));
}



class CartWatcher {

  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

 findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    //const oldCart = this.storedCart();
    //const changes = this.findCartChanges(oldCart, newCart);

    // const event = new CustomEvent("cart_changed", { detail: changes });
    // const event = new CustomEvent("cart_changed", { detail: newCart });
    const event = new CustomEvent("cart_changed");
    window.dispatchEvent(event);

    // this.storeCart(newCart);
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}


const myCartWatcher = new CartWatcher;
myCartWatcher.init();
window.addEventListener("cart_changed", updateShippingBanner);

document.addEventListener("DOMContentLoaded", updateShippingBanner);
